import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  border-bottom: solid #e6e5e7 1px;
  padding-bottom: 1rem;
`;
